<template>
  <BTooltip
    boundary-padding="10"
    v-bind="attrs"
    v-on="$listeners"
  >
    <slot />
  </BTooltip>
</template>

<script>
import {BTooltip} from 'bootstrap-vue/src/components/tooltip/tooltip'

export default {
  name: 'TTooltip',
  components: {
    BTooltip,
  },
  inheritAttrs: false,
  props: {
    /**
     * When set to 'true', changes the style of the Tooltip to `inline helper` mode
     */
    helper: {
      type: Boolean,
      default: false,
    },

    /**
     * Set the size of the tootlip. 'sm' or 'md' (default)
     */
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md'].indexOf(value) !== -1,
    },
  },
  computed: {
    attrs () {
      const attrs = this.$attrs
      const {helper} = this.$props

      attrs.customClass = attrs.customClass || ''

      if (helper) {
        attrs.customClass = 'tooltip-helper'
        attrs.boundaryPadding = 0
      }

      if (this.size === 'sm') {
        attrs.customClass = `${attrs.customClass} tooltip-sm`
      }

      return attrs
    },
  },
}
</script>

<style lang="scss">


$tooltip-font-size: $font-size-sm;
$tooltip-max-width: 420px;
$tooltip-bg: $gray-900;
$tooltip-border-radius: 2px;
$tooltip-opacity: 1;
$tooltip-padding-y: 1rem;
$tooltip-padding-x: $tooltip-padding-y;
$tooltip-arrow-width: 1rem;
$tooltip-arrow-height: 0.5rem;
$tooltip-arrow-color: $gray-900;

@import "~bootstrap/scss/_tooltip.scss";
@import "~bootstrap-vue/src/components/tooltip/index.scss";

.tooltip {
  line-height: 1.29 !important;

  &-helper {
    padding: 0;
    font-size: 12px;

    .tooltip-inner {
      color: $gray-900;
      background-color: #fff;
      padding: 0;
      font-size: 12px;
      display: flex;
      align-items: center;

      a {
        color: $gray-800;
        text-decoration: underline;

        &:hover {
          color: $primary;
        }
      }
    }

    .arrow {
      display: none;
    }
  }

  .tooltip-inner {
    text-align: left !important;
    letter-spacing: normal;
    font-weight: normal;
  }

  &-sm {
    & {
      $tooltip-padding-y: 0.216rem;
      $tooltip-padding-x: 0.5rem;

      @import "~bootstrap/scss/_tooltip.scss";

      .arrow {
        display: none;
      }
    }
  }
}
</style>
